module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/cart-414ac4dcfad4672d33aff46200ed5fca.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/cart.svg
// module id = PRNO
// module chunks = 24